export const errorTypes = {
  DEFAULT: 'default',
  DOCUMENT_IN_TRASH: 'document_in_trash',
  CREATE_DOCUMENT_FAILED: 'create_document_failed',
  NO_PUBLISHED_VERSION: 'no_published_version',
  COMPANY_NOT_AUTHORIZED: 'company_not_authorized',
};
